// extracted by mini-css-extract-plugin
export var dataCell = "_mp-2";
export var dataRow = "_mp-0";
export var headerRow = "_mp-1";